import { oz } from '@weft/utils';
import { TierUsageDataSchema } from './tier-usage-data-schema';

export const TierUsageDataInputSchema = oz
  .object(TierUsageDataSchema.shape)
  .partial()
  .required({
    tierIndex: true,
    discountConfiguration: true,
  })
  .openapi('TierUsageDataInput');

export type TierUsageDataInput = oz.infer<typeof TierUsageDataInputSchema>;